var gtm = (function () {
  var _js_jquery = "//ajax.googleapis.com/ajax/libs/jquery/2.2.1/jquery.min.js";

  var gtmPush = function (data) {
    if (typeof window.dataLayer !== "undefined") {
      window.dataLayer.push(data);
    } else {
      dataLayer.push(data);
    }
  };

  var defined = function (key, parent = null) {
    var arr = key.split(".");
    try {
      var parent = (parent !== null) ? eval(parent) : null;
      var test = (parent !== null) ? parent[eval([arr[0]])] : eval(arr[0]);
      if (typeof test === "object" && Object.keys(arr).length > 1) {
        parent = arr[0];
        arr.splice(0, 1);
        return defined(arr.join('.'), test);
      } else if (typeof test === "undefined") {
        return null;
      }
      return test;
    } catch (e) {
      return null;
  }
  };


  var click = function (element, options) {
    $(document).on("click", element, function () {
      if (typeof options === "function") {
        gtmPush(options(this));
      } else {
        gtmPush(options);
      }
    });
  };

  return {

    init: function () {
      this.checkout();
      this.newsletter();
      this.minicart();
      this.latestOffers();

      // contact us
      click('a[href$="/contact-us"]', {
        event: 'click',
        gtmAction: 'contact us',
        gtmLabel: defined("meta.page.pageType") || ""
      });
      // login
      click('a[href$="/login"]', {
        event: 'click',
        gtmAction: 'login',
        gtmLabel: defined("meta.page.pageType") || ""
      });
      // create account
      click('a[href$="/register"]', {
        event: 'click',
        gtmAction: 'create account',
        gtmLabel: defined("meta.page.pageType") || ""
      });
      // forget password
      click('#RecoverPassword', {
        event: 'click',
        gtmAction: 'forget password',
        gtmLabel: defined("meta.page.pageType") || ""
      });
      // search
      click("a[data-search-toggle]", {
        event: 'click',
        gtmAction: 'search',
        gtmLabel: 'header'
      });
    },
    minicart: function () {
      $(document).ajaxComplete(function (event, request, settings) {
        if (settings.url === "/cart/add.js" && request.status === 200) {

          if (typeof request.responseJSON !== "undefined" &&
                  typeof request.responseJSON.product_id !== "undefined") {
            gtmPush({
              event: 'click',
              gtmAction: "add to cart",
              gtmLabel: request.responseJSON.product_id,
              gtmValue: ""
            });
          }
        }
      });
    },
    newsletter: function () {
      $(document).bind('submit', function (e) {
        if ($(e.target).hasClass("contact-form")) {
          var email = $('input[name="email"]', this).val();

          gtmPush({
            event: 'submit',
            gtmAction: "footer newsletter",
            gtmLabel: email,//"",
            gtmValue: ""//
          });
        }
      });
    },
    checkout: function () {
      $(document).bind('submit', function (e) {
        if ($(e.target).hasClass("edit_checkout") && $('#checkout_reduction_code', e.target)) {
          var code = $('#checkout_reduction_code', e.target).val();

          gtmPush({
            event: 'click',
            gtmAction: "discount code",
            gtmLabel: code,//"discount code",
            gtmValue: ""//code
          });
        }
      });
    },
    latestOffers: function () {
      $(document).on("click", "a[data-latest-offers]", function (e) {
        gtmPush({
          event: 'click',
          gtmAction: 'latest offers',
          gtmLabel: $(this).data('offer'),
        });
      });
    },
    prepare: function () {
      var that = this;
      if (typeof jQuery !== "function") {
        var script = document.createElement("script");
        script.src = _js_jquery;
        script.type = 'text/javascript';
        script.onload = function () {
          that.init();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
      } else {
        that.init();
      }
    }
  };
})();

gtm.prepare();